import { useUuid } from '@procureai/ui-mui';
import { useTranslation } from 'react-i18next';

import { I18nNamespace } from '~/common/types';
import { ChatMessageProps } from '~/common/types/ChatMessage';
import { ChatActionNext } from '~/components/ChatStep/ChatActions/ChatActionNext';
import { ChatStep } from '~/components/ChatStep/ChatStep';
import { useQuoteStep } from '~/routes/IntakeDetail/steps/IntakeQuoteStep/IntakeQuoteStep.hooks.ts';

import { IntakeQuoteStepForm } from './components/IntakeQuoteStepForm/IntakeQuoteStepForm.tsx';

export const IntakeQuoteStep = ({ role, createdBy, chatSessionCompleted }: ChatMessageProps) => {
  const { t: tIntake } = useTranslation(I18nNamespace.intake);
  const { t } = useTranslation(I18nNamespace.intake, { keyPrefix: 'IntakeQuoteStep' });

  const formId = useUuid();

  const {
    submit,
    isSubmitting,
    data: { commodityGroupId, quote },
  } = useQuoteStep();

  return (
    <ChatStep
      title={tIntake('IntakeChatStep.assistant')}
      role={role}
      createdBy={createdBy}
      message={t('message')}
      footer={<ChatActionNext formId={formId} disabled={chatSessionCompleted} />}
    >
      <IntakeQuoteStepForm
        formId={formId}
        data={quote}
        lineItemFormDefaultValues={{ commodityGroupId }}
        onSubmit={submit}
        disabled={chatSessionCompleted || isSubmitting}
      />
    </ChatStep>
  );
};
